import { useEffect } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import SidebarNav from "../SidebarNav";
import NavItems from "../NavItems/NavItems";
import { motion, useCycle } from "framer-motion";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";

const NavBar = ({ onToggle }: any) => {
  const theme = useTheme();
  const [isOpen, toggleOpen] = useCycle(false, true);

  useEffect(() => {
    if (!isOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  return (
    <>
      <Box
        component={motion.div}
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        sx={{
          position: "sticky",
          top: "clamp(14px, 3vh, 28px)",
          zIndex: 20,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "0 clamp(16px, 4vw, 48px)",
          [theme.breakpoints.down(750)]: {
            display: "none",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "760px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "18px 32px",
            borderRadius: "999px",
            background: "rgba(255, 255, 255, 0.55)",
            backdropFilter: "blur(20px) saturate(180%)",
            WebkitBackdropFilter: "blur(20px) saturate(180%)",
            border: "1px solid rgba(255, 255, 255, 0.6)",
            boxShadow: "0 8px 30px rgba(31, 38, 135, 0.10)",
          }}
        >
          <Typography
            sx={{
              fontSize: "17px",
              fontFamily: "inter",
              fontWeight: 600,
            }}
          >
            louis cappell
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "clamp(16px, 2vw, 32px)",
            }}
          >
            <NavItems />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "none",
          [theme.breakpoints.down(750)]: {
            display: "block",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "var(--app-height, 100svh)",
            zIndex: 1000,
            pointerEvents: "none",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "20px",
            right: "20px",
            zIndex: 5,
            padding: "8px 18px",
            borderRadius: "999px",
            background: "rgba(255, 255, 255, 0.55)",
            backdropFilter: "blur(16px) saturate(180%)",
            WebkitBackdropFilter: "blur(16px) saturate(180%)",
            border: "1px solid rgba(255, 255, 255, 0.6)",
            pointerEvents: "none",
          }}
        >
          <Typography
            sx={{
              fontSize: "15px",
              fontFamily: "inter",
              fontWeight: 600,
            }}
          >
            louis cappell
          </Typography>
        </Box>

        <Box sx={{ pointerEvents: "auto" }}>
          <SidebarNav
            isOpen={isOpen}
            toggleOpen={() => {
              onToggle();
              toggleOpen();
            }}
          />
        </Box>
        {isOpen && (
          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.4, ease: "easeOut" }}
            sx={{
              width: "100%",
              display: "flex",
              position: "absolute",
              bottom: "clamp(48px, 12vh, 120px)",
              zIndex: 10,
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              gap: "clamp(24px, 6vw, 48px)",
              pointerEvents: "auto",
            }}
          >
            <a
              href="https://www.linkedin.com/in/louiscappell?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BVMMUvaBgRg2cKz07Yg5vcg%3D%3D"
              style={{ textDecoration: "none", color: "#030303" }}
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon sx={{ fontSize: "38px" }} />
            </a>
            <a
              href="https://github.com/LCappell"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none", color: "#030303" }}
              aria-label="GitHub"
            >
              <GitHubIcon sx={{ fontSize: "38px" }} />
            </a>
            <a
              href="mailto:louis.cappell@icloud.com"
              style={{ textDecoration: "none", color: "#030303" }}
              aria-label="Email"
            >
              <EmailIcon sx={{ fontSize: "38px" }} />
            </a>
          </Box>
        )}
      </Box>
    </>
  );
};

export default NavBar;
